import gql from "graphql-tag";

export const API_PARTNERS = gql`
  query ApiPartners {
    apiPartners {
      id
      name
    }
  }
`;

export const API_INTEGRATION = gql`
  query ApiIntegration($organizationId: ID!) {
    apiIntegration(organizationId: $organizationId) {
      id
      name
      partnerId
      partnerName
      tokenExpiry
      callLimit
      status
      downloadedAt
    }
  }
`;

export const API_KEYS = gql`
  query ApiKeys($organizationId: ID!) {
    apiKeys(organizationId: $organizationId) {
      id
      name
      partnerId
      partnerName
      tokenExpiry
      callLimit
      status
      downloadedAt
    }
  }
`;

export const GENERATE_API_CREDENTIAL = gql`
  mutation GenerateApiCredential(
    $organizationId: ID!
    $partnerId: ID!
    $name: String
    $tokenExpiry: Int!
    $callLimit: Int!
  ) {
    generateApiCredential(
      organizationId: $organizationId
      partnerId: $partnerId
      name: $name
      tokenExpiry: $tokenExpiry
      callLimit: $callLimit
    ) {
      downloadUrl
    }
  }
`;

export const REVOKE_API_KEY = gql`
  mutation RevokeApiKey($organizationId: ID!, $apiKeyId: ID) {
    revokeApiKey(organizationId: $organizationId, apiKeyId: $apiKeyId)
  }
`;
